import { Dropdown } from "antd";

interface MenuDropdownProps {
  items: any[];
  icon?: React.ReactNode;
  placement?: "topLeft" | "topRight" | "bottomLeft" | "bottomRight";
}

export default function MenuDropdown({
  items,
  icon,
  placement = "bottomRight",
}: MenuDropdownProps) {
  return (
    <Dropdown
      menu={{ items }}
      placement={placement}
      destroyOnHidden
      trigger={["click"]}
      styles={{ root: { borderRadius: "4px" } }}
      popupRender={(menu) => (
        // Menu clicks bubble through the portal to the card's onClick; stop
        // them here (after antd closes the dropdown) instead of per item.
        <div onClick={(e) => e.stopPropagation()}>{menu}</div>
      )}
    >
      <div
        data-testid="insight-card-menu-trigger"
        onClick={(e) => e.stopPropagation()}
        className="flex items-center justify-center p-2 cursor-pointer hover:bg-gray-100 rounded-sm transition-colors"
      >
        {icon ? (
          <span className="text-lg">{icon}</span>
        ) : (
          <span className="text-[#1C1B1F] text-lg">•••</span>
        )}
      </div>
    </Dropdown>
  );
}
